var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { whites, minWhites } from './white.config';
import { createBrowserHistory } from 'history';
import { loadMicroApp } from 'qiankun';
import store from '@/store/index';
var history = createBrowserHistory();
var MicroApplicationRoute = /** @class */ (function (_super) {
    __extends(MicroApplicationRoute, _super);
    function MicroApplicationRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // data
        _this.errored = false;
        _this.microApp = null;
        return _this;
    }
    Object.defineProperty(MicroApplicationRoute.prototype, "appName", {
        /* computed */
        get: function () {
            return this.formatToHump((this.pathname.indexOf('/') > -1 ? this.pathname : "/" + this.pathname).slice(1));
        },
        enumerable: false,
        configurable: true
    });
    MicroApplicationRoute.prototype.mounted = function () {
        console.log(11112, this.$refs.microRoot);
        if (this.entry) {
            this.microApp = this.loadApp(this.appName, this.$refs.microRoot, this.entry);
        }
    };
    MicroApplicationRoute.prototype.updated = function () {
        console.log(144141, this.$refs.microRoot);
        if (this.entry && this.$refs.microRoot) {
            this.microApp = this.loadApp(this.appName, this.$refs.microRoot, this.entry);
        }
    };
    /* methods */
    MicroApplicationRoute.prototype.excludeAssetFilter = function (assetUrl) {
        var assets = [].concat(Object.values(whites)).concat(Object.values(minWhites));
        // 子应用不需要重复加载，主应用加载就够了, 微应用资源（css/js) 不被 qiankun 劫持处理
        return assets.includes(assetUrl);
        // 白名单的资源不解析这样就不会重复加载
    };
    MicroApplicationRoute.prototype.formatToHump = function (value) {
        return value.replace(/\-(\w)/g, function (_, letter) { return letter.toUpperCase(); });
    };
    MicroApplicationRoute.prototype.loadMicroApplication = function (app) {
        return loadMicroApp(app, {
            sandbox: {
                strictStyleIsolation: true,
                experimentalStyleIsolation: true,
            },
            excludeAssetFilter: this.excludeAssetFilter,
        });
    };
    MicroApplicationRoute.prototype.loadApp = function (appName, container, entry) {
        var _this = this;
        var props = {
            store: store,
            mainAppHistory: history,
            chaType: 'PMS',
            customToken: 'newPmsToken',
            customUserId: 'newPmsUserId',
            customTenantId: 'newPmsCompanyId'
        };
        this.microApp = this.loadMicroApplication({
            entry: entry,
            props: props,
            name: appName,
            container: container,
        });
        this.onMicroAppChange && this.onMicroAppChange(this.microApp);
        var getStatus = this.microApp.getStatus;
        var status = getStatus();
        console.log(status);
        if (status === 'LOADING_SOURCE_CODE') {
            this.microApp.mountPromise.then(function () {
            }).catch(function (err) {
                console.log(5555, err);
                _this.errored = true;
            });
        }
        else if (status === 'LOAD_ERROR') {
            console.log('子应用加载失败');
            this.errored = false;
        }
        else if (status === 'UNMOUNTING') {
            this.microApp.unmountPromise.then(function () {
                _this.errored = false;
                // 微应用卸载
            }).cache(function () {
                console.log('子应用在卸载时报错了');
            });
        }
    };
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], MicroApplicationRoute.prototype, "pathname", void 0);
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], MicroApplicationRoute.prototype, "entry", void 0);
    __decorate([
        Prop({
            type: Function,
            default: function () { },
        })
    ], MicroApplicationRoute.prototype, "onMicroAppChange", void 0);
    MicroApplicationRoute = __decorate([
        Component({
            name: 'MicroApplicationRoute',
        })
    ], MicroApplicationRoute);
    return MicroApplicationRoute;
}(Vue));
export default MicroApplicationRoute;
